import { render, staticRenderFns } from "./audio-in-setting.vue?vue&type=template&id=1ddb8bc0&"
import script from "./audio-in-setting.vue?vue&type=script&lang=js&"
export * from "./audio-in-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports